import styled from 'styled-components';
import breakpoint from 'Styles/breakpoints';
import Button from '../Button/Button';
import ButtonIcon from '../Icons/ButtonIcon';
import { fontTitle } from '../../styles/fonts';

export const FloatingActionButton = styled.div`
  z-index: 998;
  position: fixed;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);

  ${breakpoint('medium')} {
    bottom: 16px;
  }
`;

export const FABAnimationContainer = styled.div`
  height: 48px;
  display: flex;
  flex-direction: row;
  border-radius: 24px;
  box-shadow: 0 0px 8px 4px rgba(16, 14, 32, 0.08);

  &.animate-up-appear,
  &.animate-up-enter {
    transform: translateY(calc(100% - 16px));
  }

  &.animate-up-appear-active,
  &.animate-up-enter-active {
    transform: translateY(0);
    transition: transform
      ${({ transitionDurationEnter }) => transitionDurationEnter}ms
      cubic-bezier(0, 0, 0.58, 1);
  }

  &.animate-up-exit {
    transform: translateY(0);
  }

  &.animate-up-exit-active {
    transform: translateY(calc(100% + 16px));
    transition: transform
      ${({ transitionDurationExit }) => transitionDurationExit}ms
      cubic-bezier(0, 0, 0.58, 1);
  }
`;

export const ActionLabel = styled(Button)`
  border-radius: 24px 0 0 24px;
  padding-right: 5px;
  background-color: var(--background);
  ${fontTitle(18)};
  color: var(--ring);

  &:hover,
  :active {
    opacity: 100%;
    background-color: var(--background);
  }
`;

export const RejectIcon = styled(ButtonIcon)`
  border-radius: 0 24px 24px 0;
  padding-left: 5px;
  background-color: var(--background);
  ${fontTitle(18)};
  fill: var(--ring);

  &:hover,
  :active {
    opacity: 100%;
  }
`;

export default {};
